import getFormCompletionRate from "@/components/ImplementationGuide/utils/getFormCompletionRate";
import sortedForms from "@/components/ImplementationGuide/utils/getSortedForms";
import { CompletionRateData } from "../../types";
import FormCard from "../FormCard";
import { formCardsContainerCss } from "./FormCards.style";

interface FormCardsProps {
  baseUrl: string;
  completionRates: CompletionRateData;
  fetchForCompletionRatesFailed: boolean;
  renderTopBorder?: boolean;
}

const FormCards = ({
  baseUrl,
  completionRates,
  fetchForCompletionRatesFailed,
  renderTopBorder,
}: FormCardsProps) => {
  return (
    <div css={formCardsContainerCss(renderTopBorder)}>
      {sortedForms.map((form) => {
        const { completionRate, incompleteQuestions } = getFormCompletionRate(
          form,
          completionRates,
        );
        return (
          <div key={form.slug}>
            <FormCard
              formTitle={form.title}
              cardUrl={`${baseUrl}/form/${form.slug}`}
              completionRate={completionRate}
              numberOfIncompleteQuestions={incompleteQuestions}
              hasErrors={fetchForCompletionRatesFailed}
            />
          </div>
        );
      })}
    </div>
  );
};

export default FormCards;
